import type { Ride, RideStatus } from './types';

export const STATUS_LABEL: Record<RideStatus, string> = {
  created: 'Noch nicht gestartet',
  waiting: 'Wartet am Startpunkt',
  enroute: 'Unterwegs',
  arriving_soon: 'Gleich da',
  arrived: 'Angekommen',
  cancelled: 'Abgebrochen',
};

export const STATUS_COLOR: Record<RideStatus, string> = {
  created: 'medium',
  waiting: 'medium',
  enroute: 'primary',
  arriving_soon: 'secondary',
  arrived: 'success',
  cancelled: 'danger',
};

const TIMELINE_LABEL: Record<string, string> = {
  created: 'Fahrt angelegt',
  departed: 'Losgefahren',
  arriving_soon: 'Gleich da',
  arrived: 'Angekommen',
  cancelled: 'Fahrt beendet',
  pickup_confirmed: 'Abholpunkt bestätigt',
};

export const timelineLabel = (type: string): string => TIMELINE_LABEL[type] ?? type;

export const clockTime = (at: number): string =>
  new Date(at).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

/**
 * Gilt die letzte Position noch als aktuell? Alles älter als zwei Minuten
 * kennzeichnen wir, statt es als Live-Position auszugeben.
 */
export const isPositionFresh = (ride: Ride): boolean =>
  ride.driver != null && ride.driver.ageSeconds < 120;
